import { getBlockNodeByIdx } from './getBlockNodeByIdx';

export function scrollBlockEleIntoView({ idx }: { idx: string }) {
  setTimeout(() => {
    const editBlock = getBlockNodeByIdx(idx);
    // Use a non-intrusive scroll strategy to avoid layout thrash and header jumps
    // 'nearest' keeps the element visible without forcing large container shifts
    editBlock?.scrollIntoView({
      block: 'nearest',
      inline: 'nearest' as any,
      behavior: 'auto',
    });
  }, 50);
}
